import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "agendamento" }
const _hoisted_2 = { class: "steps-info" }
const _hoisted_3 = {
  key: 0,
  class: "box-steps"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "info-formulario" }, [
  /*#__PURE__*/_createTextVNode(" Você está para iniciar o agendamento ao projeto UNIVERSITÁRIO POR UM DIA (U1D). Por favor, atenção: a partir deste ano (2024), a Coordenação do Programa Vem Saber instituiu uma TAXA DE RESERVA para garantir o agendamento. O pré-pagamento no valor de R$ 50,00 (cinquenta reais) deverá ser efetuado exclusivamente via PIX. Após o preenchimento do formulário de reserva será solicitado anexar o comprovante PIX. A atividade \"Universitário por um Dia\" tem atraído cada vez mais escolas, resultando em um aumento na demanda. A decisão de implementar o pré-pagamento visa mitigar os efeitos causados por faltas e cancelamentos muito próximos da data agendada, os quais tornam inviável a participação de outras escolas. Importante ressaltar que o valor do pré-pagamento não é reembolsável no caso de falta ou cancelamento por parte da escola. No entanto, a taxa será deduzida do valor total que a escola deverá depositar para o pagamento das refeições. O projeto U1D desenvolve-se na Sala do Conhecimento, da área 2 do campus da USP de São Carlos - SP. Acesse o link "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://goo.gl/maps/FHzPhcnqxTCYyymx5"
  }, "LINK AQUI"),
  /*#__PURE__*/_createTextVNode(", para verificar a localização. "),
  /*#__PURE__*/_createElementVNode("b", null, "Aguardamos sua visita.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "info-atencao" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Atenção:"),
  /*#__PURE__*/_createTextVNode(" Leia atentamente o Regulamento. Verifique todas as condições para que possa desfrutar de sua visita. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações da Escola")
], -1)
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "field w-full" }
const _hoisted_10 = {
  key: 0,
  class: "w-full",
  for: "inep"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = { class: "selec-escola" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Código INEP: ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Escola: ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Localização: ", -1)
const _hoisted_17 = {
  key: 1,
  class: "empty-school"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " Não foi encontrado nenhum resultado com nome ou código da Escola informado. Verifique os dados e tente novamente. Caso não tenha encontrado, peça a adição da sua Escola no WhatsApp (16) 3364 8282. ", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "erro-school"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Erro ao procurar a Escola. Tente novamente!", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 3,
  class: "info-escola"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "Código INEP: ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "Escola: ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "Localização: ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações do Responsável")
], -1)
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "field w-full" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_32 = {
  key: 0,
  class: "p-error"
}
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "field w-full" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_36 = {
  key: 0,
  class: "p-error"
}
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "field w-full" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_40 = {
  key: 0,
  class: "p-error"
}
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { class: "field w-full" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_44 = {
  key: 0,
  class: "p-error"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações da visita")
], -1)
const _hoisted_46 = { class: "grid" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "field w-full" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "info-data" }, " Apenas as datas disponíves no calendário ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 0,
  class: "num-vagas-selected"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-plus" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("b", null, "Vagas disponíveis:", -1)
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 1,
  class: "p-error"
}
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "sub-titulo-num-alunos" }, "Nº de alunos:", -1)
const _hoisted_61 = { class: "field grid" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname4",
  class: "col-3 md:mb-0"
}, [
  /*#__PURE__*/_createTextVNode("1ª série do Ensino médio "),
  /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *")
], -1)
const _hoisted_63 = { class: "col-9" }
const _hoisted_64 = { class: "field grid" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname4",
  class: "col-3 md:mb-0"
}, [
  /*#__PURE__*/_createTextVNode("2ª série do Ensino médio "),
  /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *")
], -1)
const _hoisted_66 = { class: "col-9" }
const _hoisted_67 = { class: "field grid" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname4",
  class: "col-3 md:mb-0"
}, [
  /*#__PURE__*/_createTextVNode("3ª série do Ensino médio "),
  /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *")
], -1)
const _hoisted_69 = { class: "col-9" }
const _hoisted_70 = { class: "field grid" }
const _hoisted_71 = { class: "col-9" }
const _hoisted_72 = {
  key: 0,
  class: "p-error"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações dos Professores")
], -1)
const _hoisted_74 = { class: "grid" }
const _hoisted_75 = { class: "col-12" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("p", { class: "info-professores" }, [
  /*#__PURE__*/_createTextVNode(" Informe outros Professores/Monitor que irão acompanhar os alunos no dia da visita. "),
  /*#__PURE__*/_createElementVNode("b", null, "Não adicionar o responsável do agendamento"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_77 = {
  key: 0,
  class: "p-error teacher-email-conflict"
}
const _hoisted_78 = { class: "grid" }
const _hoisted_79 = { class: "col-4" }
const _hoisted_80 = { class: "field w-full" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_82 = {
  key: 0,
  class: "p-error"
}
const _hoisted_83 = { class: "col-4" }
const _hoisted_84 = { class: "field w-full" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1)
const _hoisted_86 = {
  key: 0,
  class: "p-error"
}
const _hoisted_87 = { class: "col-3" }
const _hoisted_88 = { class: "field w-full" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "w-full" }, "Telefone", -1)
const _hoisted_90 = { class: "field w-full" }
const _hoisted_91 = { class: "col-12" }
const _hoisted_92 = { class: "flex justify-content-end" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Regulamento")
], -1)
const _hoisted_94 = { class: "grid" }
const _hoisted_95 = { class: "col-12" }
const _hoisted_96 = { class: "field-checkbox" }
const _hoisted_97 = { for: "binary" }
const _hoisted_98 = {
  key: 0,
  class: "p-error"
}
const _hoisted_99 = { class: "flex justify-content-end btn-button-footer" }
const _hoisted_100 = {
  key: 1,
  class: "box-steps"
}
const _hoisted_101 = { class: "info-formulario" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("b", null, "Art. 12 do Regulamento", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", { class: "info-formulario" }, " O pagamento das refeições deve acontecer, impreterivelmente, antes da data agendada da visita para que possamos atuar junto ao RU. Informações do PIX estarão no e-mail de confirmação do seu agendamento. ", -1)
const _hoisted_106 = { class: "grid" }
const _hoisted_107 = { class: "col-12" }
const _hoisted_108 = { class: "field-checkbox" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { for: "binary" }, " Li e estou de acordo com as informações sobre a refeição no RU. ", -1)
const _hoisted_110 = {
  key: 0,
  class: "p-error"
}
const _hoisted_111 = { class: "flex justify-content-end btn-button-footer" }
const _hoisted_112 = {
  key: 2,
  class: "box-steps"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-money-bill mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Taxa de Reserva")
], -1)
const _hoisted_114 = { class: "grid" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "info-formulario" }, [
    /*#__PURE__*/_createTextVNode(" Você está para concluir o agendamento de sua visita, por favor, efetue o pagamento da Taxa de Reserva de R$ 50,00 (cinquenta reais). "),
    /*#__PURE__*/_createElementVNode("b", null, "Este valor será descontado no valor total da refeição."),
    /*#__PURE__*/_createTextVNode(" Utilize o QR CODE ou o código do PIX Copia e Cola. ")
  ])
], -1)
const _hoisted_116 = { class: "col-12" }
const _hoisted_117 = { class: "qr-code-pix" }
const _hoisted_118 = { class: "qr-code-pix-img" }
const _hoisted_119 = { class: "col-12" }
const _hoisted_120 = { class: "box-pix-code" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("p", null, "PIX Copia e Cola", -1)
const _hoisted_122 = {
  class: "pix-code",
  readonly: "",
  rows: "3"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-copy mr-2" }, null, -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("b", null, "COPIAR CÓDIGO", -1)
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ticket mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Comprovante de depósito")
], -1)
const _hoisted_127 = { class: "grid" }
const _hoisted_128 = { class: "col-12" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", null, " Depois de ter feito o pagamento do PIX, anexar comprovante abaixo. Arquivos permitidos: JPG, PNG, GIF ou PDF ", -1)
const _hoisted_130 = {
  key: 0,
  class: "file-upload-box"
}
const _hoisted_131 = { class: "file-name-upload" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_133 = { key: 0 }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash" }, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", null, "Remover", -1)
const _hoisted_136 = [
  _hoisted_134,
  _hoisted_135
]
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "btn-upload-file" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-import" }),
  /*#__PURE__*/_createElementVNode("span", null, "Anexar comprovante")
], -1)
const _hoisted_138 = { class: "select-button" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = { key: 1 }
const _hoisted_141 = {
  key: 2,
  class: "p-error mt-1"
}
const _hoisted_142 = { class: "flex justify-content-end btn-button-footer mt-5" }
const _hoisted_143 = {
  key: 3,
  class: "box-steps"
}
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "title-resumo" }, "Resumo do agendamento", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações da Escola")
], -1)
const _hoisted_146 = { class: "grid" }
const _hoisted_147 = { class: "col-12" }
const _hoisted_148 = { class: "field w-full" }
const _hoisted_149 = {
  key: 0,
  class: "info-escola"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("b", null, "Código INEP: ", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("b", null, "Escola: ", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("b", null, "Localização: ", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações do Responsável")
], -1)
const _hoisted_154 = { class: "grid dados-respostas" }
const _hoisted_155 = { class: "col-12" }
const _hoisted_156 = { class: "field w-full" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", null, "CPF do Responsável:", -1)
const _hoisted_158 = { class: "p-resposta" }
const _hoisted_159 = { class: "col-12" }
const _hoisted_160 = { class: "field w-full" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", null, "Nome completo do responsável:", -1)
const _hoisted_162 = { class: "p-resposta" }
const _hoisted_163 = { class: "col-12" }
const _hoisted_164 = { class: "field w-full" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("label", null, "E-mail do Responsável:", -1)
const _hoisted_166 = { class: "p-resposta" }
const _hoisted_167 = { class: "col-12" }
const _hoisted_168 = { class: "field w-full" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", null, "Telefone para contato: ", -1)
const _hoisted_170 = { class: "p-resposta" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações da visita")
], -1)
const _hoisted_172 = { class: "grid dados-respostas" }
const _hoisted_173 = { class: "col-12" }
const _hoisted_174 = { class: "field w-full" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("label", null, "Data da visita: ", -1)
const _hoisted_176 = { class: "p-resposta" }
const _hoisted_177 = { class: "col-12" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("p", { class: "sub-titulo-num-alunos mt-4" }, "Nº de alunos:", -1)
const _hoisted_179 = { class: "field w-full" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("label", null, "1ª série do Ensino médio: ", -1)
const _hoisted_181 = { class: "p-resposta" }
const _hoisted_182 = { class: "field w-full" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("label", null, "2ª série do Ensino médio: ", -1)
const _hoisted_184 = { class: "p-resposta" }
const _hoisted_185 = { class: "field w-full" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("label", null, "3ª série do Ensino médio: ", -1)
const _hoisted_187 = { class: "p-resposta" }
const _hoisted_188 = { class: "field w-full" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("label", null, "Total de alunos:", -1)
const _hoisted_190 = { class: "p-resposta" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Informações dos Professores")
], -1)
const _hoisted_192 = { class: "grid dados-respostas" }
const _hoisted_193 = { class: "grid" }
const _hoisted_194 = { class: "col-5" }
const _hoisted_195 = { class: "field w-full" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("label", { class: "w-full" }, "Nome completo:", -1)
const _hoisted_197 = { class: "col-4" }
const _hoisted_198 = { class: "field w-full" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { class: "w-full" }, "E-mail:", -1)
const _hoisted_200 = { class: "col-3" }
const _hoisted_201 = { class: "field w-full" }
const _hoisted_202 = /*#__PURE__*/_createElementVNode("label", { class: "w-full" }, "Telefone:", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-money-bill mr-2" }),
  /*#__PURE__*/_createElementVNode("b", null, "Refeição")
], -1)
const _hoisted_204 = { class: "grid" }
const _hoisted_205 = { class: "col-12" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, [
  /*#__PURE__*/_createTextVNode(" O pagamento das refeições deve acontecer, impreterivelmente, antes da data agendada da visita para que possamos atuar junto ao RU. "),
  /*#__PURE__*/_createElementVNode("b", null, "Informações do PIX estarão no e-mail de confirmação do seu agendamento."),
  /*#__PURE__*/_createTextVNode(" Confira os valores da refeição: ")
], -1)
const _hoisted_207 = { class: "box-valor-deposito" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle mr-2" }),
  /*#__PURE__*/_createTextVNode(" Informação:")
], -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("p", null, "(-) Desconto Taxa de reserva = R$ 50,00", -1)
const _hoisted_210 = { class: "flex justify-content-end btn-button-footer mt-5" }
const _hoisted_211 = { class: "box-sucesso" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("p", { class: "text-sucesso-envio" }, [
  /*#__PURE__*/_createTextVNode(" O seu agendamento foi enviado para análise. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Aguarde a confirmação do agendamento no seu e-mail de cadastro.")
], -1)
const _hoisted_214 = { class: "codigo-agendamento" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("p", null, "Código de agendamento:", -1)
const _hoisted_216 = { class: "cod-agendamento-text" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("p", { class: "text-sucesso-envio" }, " Você também pode acompanhar o status do agendamento no nosso site utilizando o código de agendamento. ", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("span", { class: "header-erro-forms" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle mr-1" }),
  /*#__PURE__*/_createTextVNode(" ERRO")
], -1)
const _hoisted_219 = { class: "confirmation-content" }
const _hoisted_220 = /*#__PURE__*/_createElementVNode("p", { class: "info-calendar-modal-data" }, [
  /*#__PURE__*/_createTextVNode(" Navegue pelo calendário e clique em uma "),
  /*#__PURE__*/_createElementVNode("b", null, "data com vagas disponíveis"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_221 = ["onClick"]
const _hoisted_222 = { class: "day-label text-gray-900" }
const _hoisted_223 = { class: "flex-grow overflow-y-auto overflow-x-auto" }
const _hoisted_224 = { class: "num-vagas" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ticket" }, null, -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Art.1"),
  /*#__PURE__*/_createTextVNode(" - A participação no projeto Universitário por Um Dia (U1D) só é possível após a aprovação do Agendamento. O professor responsável é o interlocutor com o Programa Vem Saber."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.2"),
  /*#__PURE__*/_createTextVNode(" - A USP, o Programa Vem Saber e a coordenação do Universitário por Um Dia não se responsabilizam pela logística até ao campus da USP em São Carlos. Cabe ao professor responsável pelo Agendamento, que acompanhará os estudantes na visita, organizar o transporte de seus alunos. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.3"),
  /*#__PURE__*/_createTextVNode(" - As atividades do U1D estão programadas para acontecer das 9h às 16h30min. A pontualidade no horário de chegada é primordial para que a atividade proposta seja totalmente realizada. Em caso de atraso, a programação poderá sofrer alterações. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.4"),
  /*#__PURE__*/_createTextVNode(" - A taxa de reserva não será reembolsável em caso de faltas ou cancelamento."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.5"),
  /*#__PURE__*/_createTextVNode(" - A Sala do Conhecimento, local em que acontece as atividades do Universitário por um dia, comporta 60 (sessenta) pessoas sentadas. Num mesmo dia de visita poderão estar presentes mais de uma Escola, desde que atenda ao limite de lugares disponíveis (60). "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.6"),
  /*#__PURE__*/_createTextVNode(" - O professor é o agente responsável pelo monitoramento dos alunos durante as atividades e no interior do Campus USP."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.7"),
  /*#__PURE__*/_createTextVNode(" - Os visitantes deverão manter a ordem e silêncio nos corredores do edifício, especialmente por se tratar de um ambiente com salas de aula."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.8"),
  /*#__PURE__*/_createTextVNode(" - Como requisito de segurança, é indispensável que os visitantes utilizem calçados fechados, pois estarão em um laboratório. Chinelos ou outros tipos de calçados abertos não serão permitidos."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.9"),
  /*#__PURE__*/_createTextVNode(" - Não dispomos de guarda-volumes, portanto, pedimos que deixem mochilas, bolsas grandes e outros volumes no ônibus. Não é permitida a entrada nos laboratórios desses itens. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.10"),
  /*#__PURE__*/_createTextVNode(" - Durante as demonstrações dos experimentos, jogos eletrônicos e players de música deverão permanecer desligados."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.11"),
  /*#__PURE__*/_createTextVNode(" - Permite-se caneta e caderno de anotações, filmagens e fotografias."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.12"),
  /*#__PURE__*/_createTextVNode(" - Os professores e estudantes terão acesso ao Restaurante Universitário - que é parte importante da programação da visita. A refeição tem um custo por pessoa. O horário previsto para o almoço é das 11h30 às 12h45. Após o almoço, e dentro do intervalo de tempo, os estudantes poderão caminhar pelo Campus, sob a supervisão dos professores ou responsáveis."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.13"),
  /*#__PURE__*/_createTextVNode(" - É obrigatório aos estudantes preencherem o QAS (Questionário de Avaliação Socioeconômica) e atenderem à outras demandas durante a atividade."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.14"),
  /*#__PURE__*/_createTextVNode("- É proibido o consumo de alimentos e bebidas no interior da Sala do Conhecimento."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.15"),
  /*#__PURE__*/_createTextVNode(" - Para a segurança e conforto de todos não é permitido correr ou gritar em qualquer área do Conjunto de Apoio Didático, onde está localizada a Sala do Conhecimento."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.16"),
  /*#__PURE__*/_createTextVNode(" - É expressamente proibido fumar nas dependências dos prédios do Campus da USP."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.17"),
  /*#__PURE__*/_createTextVNode(" - Solicita-se que estas informações sejam repassadas aos estudantes antes da visitação."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Art.18"),
  /*#__PURE__*/_createTextVNode(" - Em caso de imprevisto no cumprimento do horário de chegada, avisar pelo "),
  /*#__PURE__*/_createElementVNode("b", null, "WhattsApp: (16) 3364 8282, o mais breve possível."),
  /*#__PURE__*/_createElementVNode("br")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.sucessoForms)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 0,
            class: "shadow-5"
          }, {
            title: _withCtx(() => [
              _createTextVNode(" Novo Agendamento ")
            ]),
            content: _withCtx(() => [
              _createVNode(_component_Steps, {
                model: _ctx.steps,
                class: "steps-agendamento"
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ 'steps-label-ativo': item.active }, "steps-label"])
                  }, _toDisplayString(item.label), 3),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.info), 1)
                ]),
                _: 1
              }, 8, ["model"]),
              (_ctx.steps[0].active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          (!_ctx.selectedClickSchool)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                                _createTextVNode("Nome ou código da Escola no INEP "),
                                _hoisted_11
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_12, [
                            (!_ctx.selectedClickSchool)
                              ? (_openBlock(), _createBlock(_component_AutoComplete, {
                                  key: 0,
                                  class: "w-full sm:w-auto",
                                  modelValue: _ctx.selectedSchool,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSchool) = $event)),
                                  suggestions: _ctx.filteredSchool,
                                  onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchSchool($event))),
                                  dropdown: false,
                                  optionLabel: "nameSchool",
                                  emptySearchMessage: "Nenhuma escola encontrada",
                                  onItemSelect: _ctx.clickSchool,
                                  placeholder: "Pesquise pelo código INEP ou nome da Escola."
                                }, {
                                  item: _withCtx((slotProps) => [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("p", null, [
                                        _hoisted_14,
                                        _createTextVNode(_toDisplayString(slotProps.item.codeInepSchool) + " - ", 1),
                                        _hoisted_15,
                                        _createTextVNode(_toDisplayString(slotProps.item.nameSchool), 1)
                                      ]),
                                      _createElementVNode("p", null, [
                                        _hoisted_16,
                                        _createTextVNode(_toDisplayString(slotProps.item.citySchool) + " - " + _toDisplayString(slotProps.item.stateSchool), 1)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onItemSelect"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.emptySchool)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                            : _createCommentVNode("", true),
                          (_ctx.erroSchool)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                            : _createCommentVNode("", true),
                          (_ctx.selectedClickSchool)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createVNode(_component_Button, {
                                  icon: "pi pi-trash",
                                  class: "p-button-danger p-button-sm btn-remove-school",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeSchool($event)))
                                }),
                                _createElementVNode("p", null, [
                                  _hoisted_24,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.codeInepSchool), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_25,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.nameSchool), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_26,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.citySchool) + " - " + _toDisplayString(_ctx.selectedSchool?.stateSchool), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.cpfResponsavel.erro }]),
                            for: "cpf"
                          }, [
                            _createTextVNode("CPF do Responsável"),
                            _hoisted_31
                          ], 2),
                          _createVNode(_component_InputMask, {
                            class: _normalizeClass(["w-full sm:w-auto", { 'p-invalid': _ctx.agendamento.cpfResponsavel.erro }]),
                            mask: "999.999.999-99",
                            id: "cpf",
                            modelValue: _ctx.agendamento.cpfResponsavel.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agendamento.cpfResponsavel.value) = $event)),
                            disabled: !_ctx.selectedClickSchool,
                            onFocusout: _ctx.checkInputCPF
                          }, null, 8, ["class", "modelValue", "disabled", "onFocusout"]),
                          (_ctx.agendamento.cpfResponsavel.erro)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_32, "Informe um CPF válido"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.nomeResponsavel.erro }]),
                            for: "name"
                          }, [
                            _createTextVNode("Nome completo do responsável"),
                            _hoisted_35
                          ], 2),
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.agendamento.nomeResponsavel.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agendamento.nomeResponsavel.value) = $event)),
                            type: "text",
                            class: _normalizeClass(["w-full", { 'p-invalid': _ctx.agendamento.nomeResponsavel.erro }]),
                            id: "name",
                            disabled: !_ctx.selectedClickSchool,
                            onFocusout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkInput(_ctx.agendamento.nomeResponsavel))),
                            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeInput(_ctx.agendamento.nomeResponsavel)))
                          }, null, 8, ["modelValue", "class", "disabled"]),
                          (_ctx.agendamento.nomeResponsavel.erro)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_36, "Informe o nome completo"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.emailResponsavel.erro }]),
                            for: "email"
                          }, [
                            _createTextVNode("E-mail do Responsável"),
                            _hoisted_39
                          ], 2),
                          _createVNode(_component_InputText, {
                            type: "email",
                            class: _normalizeClass(["w-full", { 'p-invalid': _ctx.agendamento.emailResponsavel.erro }]),
                            id: "email",
                            disabled: !_ctx.selectedClickSchool,
                            modelValue: _ctx.agendamento.emailResponsavel.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agendamento.emailResponsavel.value) = $event)),
                            onFocusout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.checkInputEmail(_ctx.agendamento.emailResponsavel))),
                            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeInputEmail(_ctx.agendamento.emailResponsavel)))
                          }, null, 8, ["class", "disabled", "modelValue"]),
                          (_ctx.agendamento.emailResponsavel.erro)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_40, "Informe um e-mail válido"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.telefoneResponsavel.erro }]),
                            for: "phone"
                          }, [
                            _createTextVNode("Telefone para contato "),
                            _hoisted_43
                          ], 2),
                          _createVNode(_component_InputMask, {
                            class: _normalizeClass(["w-full sm:w-auto", { 'p-invalid': _ctx.agendamento.telefoneResponsavel.erro }]),
                            mask: "(99) 99999999?9",
                            id: "phone",
                            disabled: !_ctx.selectedClickSchool,
                            modelValue: _ctx.agendamento.telefoneResponsavel.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.agendamento.telefoneResponsavel.value) = $event)),
                            onFocusout: _cache[11] || (_cache[11] = ($event: any) => (_ctx.checkInput(_ctx.agendamento.telefoneResponsavel)))
                          }, null, 8, ["class", "disabled", "modelValue"]),
                          (_ctx.agendamento.telefoneResponsavel.erro)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_44, "Informe um telefone para contato"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.data.erro }])
                          }, [
                            _createTextVNode("Data da visita "),
                            _hoisted_49
                          ], 2),
                          _hoisted_50,
                          _createElementVNode("div", {
                            class: "p-inputgroup click-data-modal",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onFocus: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args)))
                          }, [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.agendamento.data.value,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.agendamento.data.value) = $event)),
                              disabled: !_ctx.selectedClickSchool,
                              class: _normalizeClass({ 'p-invalid': _ctx.agendamento.data.erro }),
                              readonly: ""
                            }, null, 8, ["modelValue", "disabled", "class"]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["p-inputgroup-addon icon-btn-modal-calendar", {
                      'icon-btn-modal-calendar-disabled': !_ctx.selectedClickSchool,
                    }])
                            }, _hoisted_52, 2)
                          ], 32),
                          (_ctx.agendamento.data.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _hoisted_54,
                                _hoisted_55,
                                (_ctx.numVagas === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.numVagas) + " vaga", 1))
                                  : _createCommentVNode("", true),
                                (_ctx.numVagas > 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.numVagas) + " vagas", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.agendamento.data.erro)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_58, "Selecione uma data no calendário"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("div", _hoisted_63, [
                            _withDirectives(_createVNode(_component_InputNumber, {
                              inputId: "minmax-buttons",
                              modelValue: _ctx.agendamento.serie1.value,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.agendamento.serie1.value) = $event)),
                              mode: "decimal",
                              showButtons: "",
                              min: 0,
                              max: 100,
                              useGrouping: false,
                              disabled: !_ctx.selectedClickSchool
                            }, null, 8, ["modelValue", "disabled"]), [
                              [
                                _directive_tooltip,
                                'Nº de alunos',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, [
                            _withDirectives(_createVNode(_component_InputNumber, {
                              inputId: "minmax-buttons",
                              modelValue: _ctx.agendamento.serie2.value,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.agendamento.serie2.value) = $event)),
                              mode: "decimal",
                              showButtons: "",
                              min: 0,
                              max: 100,
                              useGrouping: false,
                              disabled: !_ctx.selectedClickSchool
                            }, null, 8, ["modelValue", "disabled"]), [
                              [
                                _directive_tooltip,
                                'Nº de alunos',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", _hoisted_69, [
                            _withDirectives(_createVNode(_component_InputNumber, {
                              inputId: "minmax-buttons",
                              modelValue: _ctx.agendamento.serie3.value,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.agendamento.serie3.value) = $event)),
                              mode: "decimal",
                              showButtons: "",
                              min: 0,
                              max: 100,
                              useGrouping: false,
                              disabled: !_ctx.selectedClickSchool
                            }, null, 8, ["modelValue", "disabled"]), [
                              [
                                _directive_tooltip,
                                'Nº de alunos',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("label", {
                            for: "firstname4",
                            class: _normalizeClass(["col-3 md:mb-0", { 'p-error': _ctx.agendamento.totalParticipantes.erro }])
                          }, "Total de alunos:", 2),
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_InputNumber, {
                              modelValue: _ctx.agendamento.totalParticipantes.value,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.agendamento.totalParticipantes.value) = $event)),
                              inputId: "withoutgrouping",
                              mode: "decimal",
                              useGrouping: false,
                              readonly: true,
                              disabled: !_ctx.selectedClickSchool,
                              class: _normalizeClass({
                      'p-invalid': _ctx.agendamento.totalParticipantes.erro,
                    })
                            }, null, 8, ["modelValue", "disabled", "class"]),
                            (_ctx.agendamento.totalParticipantes.erro)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_72, _toDisplayString(_ctx.textErroTotalAlunos), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_73
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        (_ctx.textErroProfessores)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_77, _toDisplayString(_ctx.textErroProfessores), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professores, (line, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(["w-full", { 'p-error': line.nameTeachers.erro }])
                                }, [
                                  _createTextVNode("Nome completo "),
                                  _hoisted_81
                                ], 2),
                                _createVNode(_component_InputText, {
                                  modelValue: line.nameTeachers.value,
                                  "onUpdate:modelValue": ($event: any) => ((line.nameTeachers.value) = $event),
                                  type: "text",
                                  class: _normalizeClass(["w-full", { 'p-invalid': line.nameTeachers.erro }]),
                                  disabled: !_ctx.selectedClickSchool,
                                  onFocusout: ($event: any) => (_ctx.checkInput(line.nameTeachers)),
                                  onInput: ($event: any) => (_ctx.changeInput(line.nameTeachers))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "disabled", "onFocusout", "onInput"]),
                                (line.nameTeachers.erro)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_82, "Informe o nome do professor"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(["w-full", { 'p-error': line.emailTeachers.erro }])
                                }, [
                                  _createTextVNode("E-mail "),
                                  _hoisted_85
                                ], 2),
                                _createVNode(_component_InputText, {
                                  modelValue: line.emailTeachers.value,
                                  "onUpdate:modelValue": ($event: any) => ((line.emailTeachers.value) = $event),
                                  type: "email",
                                  class: _normalizeClass(["w-full", { 'p-invalid': line.emailTeachers.erro }]),
                                  disabled: !_ctx.selectedClickSchool,
                                  onFocusout: ($event: any) => (_ctx.checkInputEmail(line.emailTeachers)),
                                  onInput: ($event: any) => (_ctx.changeInputEmail(line.emailTeachers))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onFocusout", "onInput"]),
                                (line.emailTeachers.erro)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_86, "Informe o E-mail válido do professor"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, [
                                _hoisted_89,
                                _createVNode(_component_InputMask, {
                                  modelValue: line.phoneTeachers.value,
                                  "onUpdate:modelValue": ($event: any) => ((line.phoneTeachers.value) = $event),
                                  class: "w-full",
                                  mask: "(99) 99999-9999",
                                  disabled: !_ctx.selectedClickSchool
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["col-1 display-end", {
                    'erro-btn-remove':
                      line.emailTeachers.erro || line.nameTeachers.erro,
                  }])
                            }, [
                              _createElementVNode("div", _hoisted_90, [
                                _createVNode(_component_Button, {
                                  onClick: ($event: any) => (_ctx.removeProfessor(index)),
                                  class: "p-button p-button-danger w-full",
                                  icon: "pi pi-trash"
                                }, null, 8, ["onClick"])
                              ])
                            ], 2)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createVNode(_component_Button, {
                            label: "Adicionar Professor",
                            icon: "pi pi-plus",
                            class: "p-button-sm",
                            onClick: _ctx.addProfessor,
                            disabled: !_ctx.selectedClickSchool
                          }, null, 8, ["onClick", "disabled"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_93
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_Checkbox, {
                            inputId: "binary",
                            modelValue: _ctx.agendamento.regulamento.value,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.agendamento.regulamento.value) = $event)),
                            binary: true,
                            disabled: !_ctx.selectedClickSchool,
                            class: _normalizeClass({ 'p-invalid': _ctx.agendamento.regulamento.erro }),
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.checkRegulamento()))
                          }, null, 8, ["modelValue", "disabled", "class"]),
                          _createElementVNode("label", _hoisted_97, [
                            _createTextVNode(" Li e estou ciente do "),
                            _createElementVNode("span", {
                              class: "link-regulamento",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.statusRegulamento(true, false)))
                            }, "regulamento"),
                            _createTextVNode(" e concordo com os termos descritos. ")
                          ])
                        ]),
                        (_ctx.agendamento.regulamento.erro)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_98, "É nescessário aceitar o regulamento e termos para continuar o agendamento"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createVNode(_component_Button, {
                        disabled: !_ctx.selectedClickSchool,
                        class: "p-button-success w-full",
                        iconPos: "right",
                        icon: "pi pi-arrow-right",
                        label: "AVANÇAR",
                        onClick: _ctx.step1
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.steps[1].active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createElementVNode("p", _hoisted_101, [
                      _createTextVNode(" É com grande satisfação que recebemos seu agendamento para o projeto UNIVERSITÁRIO POR UM DIA (U1D). "),
                      _hoisted_102,
                      _hoisted_103,
                      _createTextVNode(" Conforme estabelecido no "),
                      _hoisted_104,
                      _createTextVNode(", a refeição no Restaurante Universitário tem um custo de R$ " + _toDisplayString(_ctx.valorUnidade) + ",00 por pessoa. Estar no RU, em conjunto com os estudantes da USP, é um momento de vivência do ambiente universitário ", 1)
                    ]),
                    _hoisted_105,
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _createVNode(_component_Checkbox, {
                            inputId: "binary",
                            modelValue: _ctx.regulamentoAlmoco.value,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.regulamentoAlmoco.value) = $event)),
                            binary: true,
                            class: _normalizeClass({ 'p-invalid': _ctx.regulamentoAlmoco.erro })
                          }, null, 8, ["modelValue", "class"]),
                          _hoisted_109
                        ]),
                        (_ctx.regulamentoAlmoco.erro)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_110, "É nescessário aceitar os termos para continuar o agendamento"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _createVNode(_component_Button, {
                        disabled: !_ctx.selectedClickSchool,
                        class: "p-button-secondary w-full btn-button-footer-l",
                        iconPos: "left",
                        icon: "pi pi-arrow-left",
                        label: "VOLTAR",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.voltarStep(0)))
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_Button, {
                        disabled: !_ctx.selectedClickSchool,
                        class: "p-button-success w-full btn-button-footer-r",
                        iconPos: "right",
                        icon: "pi pi-arrow-right",
                        label: "AVANÇAR",
                        onClick: _ctx.step2
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.steps[2].active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _createVNode(_component_Divider, { align: "left" }, {
                      default: _withCtx(() => [
                        _hoisted_113
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _createVNode(_component_qrcode_vue, {
                              value: _ctx.codigoPix,
                              size: 200,
                              level: "Q",
                              "render-as": "svg"
                            }, null, 8, ["value"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _hoisted_121,
                          _createElementVNode("textarea", _hoisted_122, _toDisplayString(_ctx.codigoPix), 1),
                          _createElementVNode("button", {
                            class: "btn-copy-pix",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.copiarTexto()))
                          }, _hoisted_125)
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, {
                      align: "left",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_126
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _hoisted_129,
                        (_ctx.file)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                              _createElementVNode("div", _hoisted_131, [
                                _hoisted_132,
                                (_ctx.file?.name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_133, _toDisplayString(_ctx.file.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: "btn-remove-file",
                                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.removeUpload && _ctx.removeUpload(...args)))
                              }, _hoisted_136)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.file)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 1,
                              class: _normalizeClass(["file-select", { 'file-select-erro': _ctx.erroUpload }])
                            }, [
                              _hoisted_137,
                              _createElementVNode("div", _hoisted_138, [
                                (_ctx.file?.name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_139, _toDisplayString(_ctx.file.name), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_140, "Sem anexo de comprovante"))
                              ]),
                              _createElementVNode("input", {
                                type: "file",
                                onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                              }, null, 32)
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.erroUpload)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_141, "Anexar comprovante!"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_Button, {
                        class: "p-button-secondary w-full btn-button-footer-l",
                        iconPos: "left",
                        icon: "pi pi-arrow-left",
                        label: "VOLTAR",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.voltarStep(1)))
                      }),
                      _createVNode(_component_Button, {
                        disabled: !_ctx.file,
                        class: "p-button-success w-full btn-button-footer-r",
                        iconPos: "right",
                        icon: "pi pi-arrow-right",
                        label: "AVANÇAR",
                        onClick: _ctx.step3
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.steps[3].active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                    _hoisted_144,
                    _createVNode(_component_Divider, {
                      align: "left",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_145
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          (_ctx.selectedClickSchool)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                _createElementVNode("p", null, [
                                  _hoisted_150,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.codeInepSchool), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_151,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.nameSchool), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_152,
                                  _createTextVNode(_toDisplayString(_ctx.selectedSchool?.citySchool) + " - " + _toDisplayString(_ctx.selectedSchool?.stateSchool), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, {
                      align: "left",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_153
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("div", _hoisted_156, [
                          _hoisted_157,
                          _createElementVNode("p", _hoisted_158, _toDisplayString(_ctx.agendamento.cpfResponsavel.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("div", _hoisted_160, [
                          _hoisted_161,
                          _createElementVNode("p", _hoisted_162, _toDisplayString(_ctx.agendamento.nomeResponsavel.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("div", _hoisted_164, [
                          _hoisted_165,
                          _createElementVNode("p", _hoisted_166, _toDisplayString(_ctx.agendamento.emailResponsavel.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          _hoisted_169,
                          _createElementVNode("p", _hoisted_170, _toDisplayString(_ctx.agendamento.telefoneResponsavel.value), 1)
                        ])
                      ])
                    ]),
                    _createVNode(_component_Divider, {
                      align: "left",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_171
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _createElementVNode("div", _hoisted_174, [
                          _hoisted_175,
                          _createElementVNode("p", _hoisted_176, _toDisplayString(_ctx.agendamento.data.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_177, [
                        _hoisted_178,
                        _createElementVNode("div", _hoisted_179, [
                          _hoisted_180,
                          _createElementVNode("p", _hoisted_181, _toDisplayString(_ctx.agendamento.serie1.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_182, [
                          _hoisted_183,
                          _createElementVNode("p", _hoisted_184, _toDisplayString(_ctx.agendamento.serie2.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_185, [
                          _hoisted_186,
                          _createElementVNode("p", _hoisted_187, _toDisplayString(_ctx.agendamento.serie3.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_188, [
                          _hoisted_189,
                          _createElementVNode("p", _hoisted_190, _toDisplayString(_ctx.agendamento.totalParticipantes.value), 1)
                        ])
                      ])
                    ]),
                    (_ctx.professores?.length)
                      ? (_openBlock(), _createBlock(_component_Divider, {
                          key: 0,
                          align: "left",
                          class: "mt-5"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_191
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_192, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professores, (line, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_193, [
                            _createElementVNode("div", _hoisted_194, [
                              _createElementVNode("div", _hoisted_195, [
                                _hoisted_196,
                                _createElementVNode("p", null, _toDisplayString(line.nameTeachers.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_197, [
                              _createElementVNode("div", _hoisted_198, [
                                _hoisted_199,
                                _createElementVNode("p", null, _toDisplayString(line.emailTeachers.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_200, [
                              _createElementVNode("div", _hoisted_201, [
                                _hoisted_202,
                                _createElementVNode("p", null, _toDisplayString(line.phoneTeachers.value), 1)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_Divider, {
                      align: "left",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_203
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_204, [
                      _createElementVNode("div", _hoisted_205, [
                        _hoisted_206,
                        _createElementVNode("div", _hoisted_207, [
                          _hoisted_208,
                          _createElementVNode("p", null, " (+) " + _toDisplayString(_ctx.agendamento.serie1.value +
                    _ctx.agendamento.serie2.value +
                    _ctx.agendamento.serie3.value +
                    1 +
                    _ctx.professores.length) + " pessoas x R$ " + _toDisplayString(_ctx.valorUnidade) + ",00 = R$ " + _toDisplayString(_ctx.valorUnidade *
                    (_ctx.agendamento.serie1.value +
                      _ctx.agendamento.serie2.value +
                      _ctx.agendamento.serie3.value +
                      1 +
                      _ctx.professores.length)) + ",00 ", 1),
                          _hoisted_209,
                          _createElementVNode("p", null, [
                            _createElementVNode("b", null, "Valor da refeição para PIX = R$ " + _toDisplayString(_ctx.valorUnidade *
                        (_ctx.agendamento.serie1.value +
                          _ctx.agendamento.serie2.value +
                          _ctx.agendamento.serie3.value +
                          1 +
                          _ctx.professores.length) -
                      50) + ",00 ", 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_210, [
                      _createVNode(_component_Button, {
                        class: "p-button-secondary w-full btn-button-footer-l",
                        iconPos: "left",
                        icon: "pi pi-arrow-left",
                        label: "VOLTAR",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.voltarStep(2)))
                      }),
                      _createVNode(_component_Button, {
                        disabled: !_ctx.selectedClickSchool,
                        class: "p-button-success w-full btn-button-footer-r",
                        iconPos: "right",
                        icon: "pi pi-check",
                        label: "ENVIAR",
                        onClick: _ctx.submitForms
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.sucessoForms)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "shadow-5"
          }, {
            title: _withCtx(() => [
              _createTextVNode(" Sucesso ")
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_211, [
                _hoisted_212,
                _hoisted_213,
                _createElementVNode("div", _hoisted_214, [
                  _hoisted_215,
                  _createElementVNode("div", _hoisted_216, _toDisplayString(_ctx.codigoAgendamento), 1)
                ]),
                _hoisted_217
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.erroForms.active,
      "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.erroForms.active) = $event)),
      header: "Erro",
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '350px' },
      modal: true,
      closable: false
    }, {
      header: _withCtx(() => [
        _hoisted_218
      ]),
      footer: _withCtx(() => [
        (_ctx.erroForms.buttom)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.erroForms.active = false)),
              class: "p-button-danger p-button-sm",
              style: {"margin":"0"},
              label: "Ok",
              icon: "pi pi-check"
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_219, [
          _createElementVNode("span", null, _toDisplayString(_ctx.erroForms.message), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.displayCalendar,
      "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.displayCalendar) = $event)),
      header: "Selecione uma data",
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '80vw' },
      modal: true
    }, {
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _hoisted_220,
        _createVNode(_component_v_calendar, {
          class: "custom-calendar max-w-full",
          masks: _ctx.masks,
          attributes: _ctx.attributes,
          "disable-page-swipe": "",
          "is-expanded": ""
        }, {
          "day-content": _withCtx(({ day, attributes }) => [
            _createElementVNode("div", {
              onClick: ($event: any) => (attributes[0].customData?.vagas ? _ctx.onDayClick(day) : null),
              class: _normalizeClass(["flex day-click flex-col h-full z-10 overflow-hidden", {
            'vaga-cor-dia': attributes?.length,
            'vaga-ativo': attributes?.length && attributes[0].customData?.vagas,
          }])
            }, [
              _createElementVNode("div", _hoisted_222, [
                _createElementVNode("span", null, _toDisplayString(day.day), 1)
              ]),
              _createElementVNode("div", _hoisted_223, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes, (attr) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: attr.key,
                    class: "text-xs rounded-sm mt-0 mb-1"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["box-color-day", attr.customData?.classColor])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_224, [
                      _createElementVNode("span", null, [
                        _hoisted_225,
                        _createTextVNode(" " + _toDisplayString(attr.customData.vagas) + " vagas disponíveis", 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ], 10, _hoisted_221)
          ]),
          _: 1
        }, 8, ["masks", "attributes"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "Regulamento",
      visible: _ctx.displayMaximizable,
      "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.displayMaximizable) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' },
      maximizable: true,
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Não confirmar",
          icon: "pi pi-times",
          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.statusRegulamento(false, false))),
          class: "p-button-text"
        }),
        _createVNode(_component_Button, {
          label: "Confirmar",
          icon: "pi pi-check",
          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.statusRegulamento(false, true))),
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _hoisted_226
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Toast, { position: "top-center" }),
    _createVNode(_component_ConfirmPopup)
  ], 64))
}